<div class="container-fluid m-0 p-0" *ngIf="!showLoader">

    <form [formGroup]="createcourseAssUnit" (change)="createcourseAssUnitChange()"
        (submit)="createcourseAssUnitSubmit()">



        <div class="row bg-white page-head p-3 d-flex flex-wrap justify-content-between">
            <div class="col-md-6 d-flex align-self-center justify-content-center justify-content-lg-start">
                <h6 class="font-bold m-0">{{"CREATE_COURSE_ASSESSMENT_UNIT" | translate | titlecase }}</h6>
            </div>
            <div class="col-md-6 d-flex flex-wrap justify-content-center justify-content-lg-end">
                <button type="button" class="btn btn-outline-secondary m-2 rounded-0"
                    routerLink="/scores-grades/course-assessment-units" *ngIf="!creating">
                    {{"CANCEL" | translate | titlecase }}</button>
                <button type="submit" class="btn btn-primary m-2 rounded-0" *ngIf="!creating"><i
                        class="fas fa-user-plus"></i>
                    {{"SAVE" | translate | titlecase }}</button>
                <app-loader [show]="creating"></app-loader>
            </div>


        </div>

        <div class="row mt-4">

            <div class="col-12">

                <div class="row bg-white border m-0 py-3 ">
                    <!-- <div class="col-md-10 mx-md-auto pt-md-5 px-md-5">
                        <img src="assets/images/avatar.png" class="img-fluid">
                    </div> -->

                    <div class="col-md-10 mx-md-auto py-3">
                        <div class="row">
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "COURSE" | translate | titlecase
                                    }}</label>
                                <select class="form-control custom-select" formControlName="subjectid">
                                    <option value="" [selected]="true">{{ "SELECT" | translate | titlecase
                                        }}
                                    </option>
                                    <option *ngFor="let field of courses" [ngValue]="field.subjectid">
                                        {{
                                        (globals.lang == 'ar')? field?.subjectNameAr : field?.subjectNameEn
                                        }}
                                    </option>
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createcourseAssUnit.controls.subjectid.touched && createcourseAssUnit.controls.subjectid.invalid && createcourseAssUnit.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "ASSESS_UNIT" | translate | titlecase
                                    }}</label>
                                <select class="form-control custom-select" formControlName="asesid">
                                    <option value="" [selected]="true">{{ "SELECT" | translate | titlecase
                                        }}
                                    </option>
                                    <option *ngFor="let field of assUnits" [ngValue]="field.id">
                                        {{
                                        (globals.lang == 'ar')? field?.asesUnitNameAr : field?.asesUnitNameEn
                                        }}
                                    </option>
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createcourseAssUnit.controls.asesid.touched && createcourseAssUnit.controls.asesid.invalid && createcourseAssUnit.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <!-- <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"LETTER_GRADE" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="letterGrade">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createcourseAssUnit.controls.letterGrade.touched && createcourseAssUnit.controls.letterGrade.invalid && createcourseAssUnit.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div> -->
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"EXAM_NAME_AR" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="subjAsesNameAr">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createcourseAssUnit.controls.subjAsesNameAr.touched && createcourseAssUnit.controls.subjAsesNameAr.invalid && createcourseAssUnit.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"EXAM_NAME_EN" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="subjAsesNameEn">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createcourseAssUnit.controls.subjAsesNameEn.touched && createcourseAssUnit.controls.subjAsesNameEn.invalid && createcourseAssUnit.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "TYPE" | translate | titlecase
                                    }}</label>
                                <select class="form-control custom-select" formControlName="asesType">
                                    <option value="ONGOING">{{ "ONGOING" | translate | titlecase
                                        }}
                                    </option>
                                    <option value="FINAL">{{ "FINAL" | translate | titlecase
                                        }}
                                    </option>
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createcourseAssUnit.controls.asesType.touched && createcourseAssUnit.controls.asesType.invalid && createcourseAssUnit.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"ORDER" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="orderNo">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createcourseAssUnit.controls.orderNo.touched && createcourseAssUnit.controls.orderNo.invalid && createcourseAssUnit.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>

                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"SCORE" | translate | titlecase }} </label>
                                <input type="text" class="form-control" formControlName="totalScore">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createcourseAssUnit.controls.totalScore.touched && createcourseAssUnit.controls.totalScore.invalid && createcourseAssUnit.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>

                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"WEIGHT" | translate | titlecase }} </label>
                                <input type="text" class="form-control" formControlName="totalScorePercent">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createcourseAssUnit.controls.totalScorePercent.touched && createcourseAssUnit.controls.totalScorePercent.invalid && createcourseAssUnit.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>

<app-loader [attr.show]="showLoader"></app-loader>
